import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

export default function Ticker({ firms = [] }) {
  const items = firms.length
    ? firms.map((f) => `${f.name} · ${f.payouts_paid || "—"} PAID · ${f.profit_split} SPLIT · RATED ${f.rating.toFixed(1)}`)
    : ["TERMINALEDGE · PROP FIRM INTELLIGENCE · VERIFIED PAYOUTS · INDEPENDENT RATINGS"];
  return (
    <div className="border-y border-line bg-surface/70 py-3" data-testid="ticker-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-muted">
            <Sparkles size={12} className="text-signal" />
            {item}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
